import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');

    if (message.length > 500) {
      setError('Die Nachricht darf maximal 500 Zeichen enthalten.');
      return;
    }

    const form = e.currentTarget;
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });
    data.append('form_type', 'kontakt');

    setLoading(true);
    try {
      const res = await fetch('https://readdy.ai/api/form/d7fjrm95vm7vckkoe5sg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
        navigate('/danke?typ=kontakt');
      } else {
        setError('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt unter anfrage@gowitec.de.');
      }
    } catch {
      setError('Verbindungsfehler. Bitte kontaktieren Sie uns direkt unter anfrage@gowitec.de.');
    } finally {
      setLoading(false);
    }
  };

  // ... existing code ...

  return (
    <div className="bg-white border border-gray-100 rounded-xl p-6 md:p-8">
      <h2 className="text-xl font-bold text-gray-900 mb-2 flex items-center gap-3">
        <span className="w-8 h-8 flex items-center justify-center bg-[#1E3A8A]/10 rounded-lg">
          <i className="ri-send-plane-line text-[#1E3A8A] text-lg"></i>
        </span>
        Nachricht senden
      </h2>
      <p className="text-gray-500 text-sm mb-6 ml-11">
        Füllen Sie das Formular aus – wir antworten schnell und unkompliziert.
      </p>

      <form
        id="kontakt-form"
        data-readdy-form
        onSubmit={handleSubmit}
        className="flex flex-col gap-4"
      >
        {/* Honeypot – für Bots unsichtbar */}
        <div style={{ display: 'none' }} aria-hidden="true">
          <input type="text" name="website" tabIndex={-1} autoComplete="off" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label htmlFor="name" className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1.5">
              Name <span className="text-red-500">*</span>
            </label>
            <input
              id="name"
              name="name"
              type="text"
              required
              placeholder="Max Mustermann"
              className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#1E3A8A] focus:ring-1 focus:ring-[#1E3A8A]/30 transition-colors"
            />
          </div>
          <div>
            <label htmlFor="firma" className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1.5">
              Firma
            </label>
            <input
              id="firma"
              name="firma"
              type="text"
              placeholder="Musterfirma GmbH"
              className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#1E3A8A] focus:ring-1 focus:ring-[#1E3A8A]/30 transition-colors"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label htmlFor="email" className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1.5">
              E-Mail <span className="text-red-500">*</span>
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              placeholder="max@musterfirma.de"
              className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#1E3A8A] focus:ring-1 focus:ring-[#1E3A8A]/30 transition-colors"
            />
          </div>
          <div>
            <label htmlFor="telefon" className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1.5">
              Telefon
            </label>
            <input
              id="telefon"
              name="telefon"
              type="tel"
              placeholder="+49 (0) 2265 – ..."
              className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#1E3A8A] focus:ring-1 focus:ring-[#1E3A8A]/30 transition-colors"
            />
          </div>
        </div>

        <div>
          <label htmlFor="nachricht" className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1.5">
            Nachricht <span className="text-red-500">*</span>
          </label>
          <textarea
            id="nachricht"
            name="nachricht"
            required
            rows={5}
            maxLength={500}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Beschreiben Sie kurz Ihr Anliegen oder Projekt..."
            className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#1E3A8A] focus:ring-1 focus:ring-[#1E3A8A]/30 transition-colors resize-none"
          />
          <p className={`text-xs mt-1 text-right ${message.length > 480 ? 'text-red-500' : 'text-gray-400'}`}>
            {message.length}/500 Zeichen
          </p>
        </div>

        <div className="flex items-start gap-3">
          <input
            id="datenschutz"
            name="datenschutz"
            type="checkbox"
            required
            className="mt-0.5 w-4 h-4 accent-[#1E3A8A] cursor-pointer shrink-0"
          />
          <label htmlFor="datenschutz" className="text-xs text-gray-500 leading-relaxed cursor-pointer">
            Ich habe die{' '}
            <a href="/datenschutz" className="text-[#1E3A8A] underline">Datenschutzerklärung</a>{' '}
            gelesen und stimme der Verarbeitung meiner Daten zur Bearbeitung meiner Anfrage zu. <span className="text-red-500">*</span>
          </label>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-md px-4 py-3 text-sm text-red-600 flex items-center gap-2">
            <span className="w-4 h-4 flex items-center justify-center shrink-0">
              <i className="ri-error-warning-line"></i>
            </span>
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="bg-[#1E3A8A] text-white text-sm font-semibold px-6 py-3 rounded-md hover:bg-[#1e40af] transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed mt-1"
        >
          {loading ? (
            <>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-loader-4-line animate-spin"></i>
              </span>
              Wird gesendet...
            </>
          ) : (
            <>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-send-plane-fill"></i>
              </span>
              Nachricht senden
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
